import { Component } from '@angular/core';

// AC-4598: public domiiRescue support page linked from the App Store and Google Play listings.
@Component({
  selector: 'app-rescue-support',
  templateUrl: './rescue-support.component.html',
  styleUrls: ['../rescue-privacy/rescue-legal.scss']
})
export class RescueSupportComponent { }
